<template>
  <div class="f-row ctr select-form" @click="toogleContext">
    <div class="f-row full select-label">
      <span v-if="multi && value.length > 0"
        >{{ value.length }} {{ name }}</span
      >
      <span v-else>{{ name }}</span>
      <Icon :icon="displayContext ? 'chevron-up' : 'chevron-down'" />
    </div>
    <transition name="slide-fade">
      <div class="f-col select-context" v-if="displayContext" @click.stop>
        <label
          class="select-item"
          v-for="(item, index) in options"
          :key="index"
        >
          <input
            class="select-item-input"
            type="checkbox"
            :value="item.id"
            :checked="handleCheck(item)"
            @change="handleChange"
          />
          <div class="select-item-content">
            <span>{{ item.name }}</span>
          </div>
        </label>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  props: {
    name: String,
    multi: Boolean,
    options: Array,
    value: [Array, String],
  },
  data() {
    return {
      displayContext: false,
      // didScroll: false,
    };
  },
  methods: {
    openContext() {
      this.displayContext = true;
    },
    closeContext(evt) {
      if (evt.target === this.$el) return;
      this.displayContext = false;
    },
    toogleContext() {
      this.displayContext = !this.displayContext;
    },
    handleCheck(item) {
      if (this.multi) {
        return this.value.indexOf(item.id?.toString()) !== -1;
      } else {
        return this.value === item.id?.toString();
      }
    },
    handleChange(evt) {
      if (this.multi) {
        if (evt.target.checked)
          this.$emit("change", [...this.value, evt.target.value]);
        else
          this.$emit(
            "change",
            this.value.filter((value) => value !== evt.target.value)
          );
      } else {
        this.$emit("change", evt.target.value);
        setTimeout(() => {
          this.displayContext = false;
        }, 100);
      }
    },
  },
  mounted() {
    window?.addEventListener("click", this.closeContext);
    // window?.addEventListener("scroll", this.closeContext);
  },
  beforeDestroy() {
    window?.removeEventListener("click", this.closeContext);
    // window?.removeEventListener("scroll", this.closeContext);
  },
};
</script>

<style scoped>
* {
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.select-form {
  position: relative;
  height: 46px;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  border: none;
  color: #363636;
  background-color: initial;
}

.select-label {
  pointer-events: none;
  justify-content: space-between;
  padding: 0 15px 0 20px;
  font-size: 14px;
  text-transform: uppercase;
}

.select-label > span {
  align-self: center;
  justify-self: center;
  margin: 0 auto;
}

.select-context {
  justify-content: flex-start;
  position: absolute;
  top: 48px;
  right: 0;
  left: 0;
  max-height: 60vh;
  padding: 10px;
  z-index: 900;
  overflow-x: auto;
  font-size: 14px;
  text-transform: none;
  border-radius: 0.2rem;
  border: 1px solid rgba(59, 64, 71, 0.3);
  color: #333;
  background-color: #f6f6f6;
  box-shadow: 0 8px 34px rgba(59, 64, 71, 0.3);
}

.select-item {
  margin-bottom: 4px;
}

.select-item:last-of-type {
  margin-bottom: 0;
}

.select-item-content {
  padding: 4px 8px;
  border-radius: 0.25rem;
  transition: background-color 200ms ease;
}

.select-item-content > span {
  display: block;
}

.select-item-content:hover {
  color: var(--primary-color);
}

.select-item-input {
  display: none;
}

.select-item-input:checked + .select-item-content {
  color: var(--secondary-font-color) !important;
  background-color: var(--secondary-color) !important;
}

.slide-fade-enter-active {
  transition: all 150ms ease;
}

.slide-fade-leave-active {
  transition: all 150ms cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter {
  transform: translateY(-30px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}
</style>